export const HIDE_WEEKENDS_SETTING_KEY = "hideWeekends";

export function isHideWeekendsEnabled(settings = {}) {
  return Boolean(settings?.[HIDE_WEEKENDS_SETTING_KEY]);
}

export function isWeekendDate(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return false;
  }

  const day = date.getDay();
  return day === 0 || day === 6;
}

export function shiftLocalDate(date, dayDelta, { skipWeekends = false } = {}) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime()) || !Number.isFinite(dayDelta)) {
    return date;
  }

  let next = new Date(date.getFullYear(), date.getMonth(), date.getDate() + dayDelta);
  if (!skipWeekends) {
    return next;
  }

  const step = dayDelta < 0 ? -1 : 1;
  let guard = 0;
  while (isWeekendDate(next) && guard < 14) {
    next = new Date(next.getFullYear(), next.getMonth(), next.getDate() + step);
    guard += 1;
  }
  return next;
}

